import $ from 'jquery';
import Texter from "../texter.es6";
import Modaller from "./../modaller";

export default class PackAction {
    constructor(opts) {
        this.opts = opts || {};
        this.l18n = Texter.create(opts.l18n);
    }

    getTitleKey() {
        return 'title'
    }

    _showForbidden(text, buttonPre) {
        buttonPre = this.l18n.get(buttonPre);

        const template = `
    <p class="text-center">${this.l18n.get(text)}</p>
    <p class="text-center"><span style="margin-right: 1em;">${buttonPre}</span><a href="/login" class="btn btn-primary">${this.l18n.get('packPage.dialogs.login')}</a></p>
`;
        Modaller.showLocal(template, modaller => {
            modaller.setTitle(this.l18n.get(this.getTitleKey()));
            modaller.addShowListener(() => {
                this._onModalShown();
            });
        });
    }

    _onModalShown() {
        if ($.isFunction(this.opts.modalShown)) {
            this.opts.modalShown();
        }
    }
}